import { ProgressCircle } from "../../../components/progressCircle/progressCircle.jsx";
import { ProgressLine } from "../../../components/progressLine/progressLine.jsx";
import { UpArrow } from "../../../assets/icons.jsx";
import { Image } from "../../../components/image/image.jsx"
import { useId } from 'react';
import { useEffect } from 'react';
import { getDate } from "../../../utils/getStrDate.js";

import styles from "./mainPageComponents.module.css"

const Star = ({ progress }) => {
  const id = useId();
  const clipId = `star-clip-${id}`;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.62753 4.50699C8.68337 2.61366 9.21087 1.66699 10 1.66699C10.7892 1.66699 11.3167 2.61366 12.3725 4.50699L12.6459 4.99699C12.9459 5.53533 13.0959 5.80449 13.3292 5.98199C13.5625 6.15949 13.8542 6.22533 14.4375 6.35699L14.9675 6.47699C17.0175 6.94116 18.0417 7.17283 18.2859 7.95699C18.5292 8.74033 17.8309 9.55783 16.4334 11.192L16.0717 11.6145C15.675 12.0787 15.4759 12.3112 15.3867 12.5978C15.2975 12.8853 15.3275 13.1953 15.3875 13.8145L15.4425 14.3787C15.6534 16.5595 15.7592 17.6495 15.1209 18.1337C14.4825 18.6178 13.5225 18.1762 11.6042 17.2928L11.1067 17.0645C10.5617 16.8128 10.2892 16.6878 10 16.6878C9.71087 16.6878 9.43837 16.8128 8.89337 17.0645L8.3967 17.2928C6.47753 18.1762 5.51753 18.6178 4.88003 18.1345C4.24087 17.6495 4.3467 16.5595 4.55753 14.3787L4.61253 13.8153C4.67253 13.1953 4.70253 12.8853 4.61253 12.5987C4.5242 12.3112 4.32503 12.0787 3.92837 11.6153L3.5667 11.192C2.1692 9.55866 1.47087 8.74116 1.7142 7.95699C1.95753 7.17283 2.98337 6.94033 5.03337 6.47699L5.56337 6.35699C6.14587 6.22533 6.4367 6.15949 6.67087 5.98199C6.90503 5.80449 7.0542 5.53533 7.3542 4.99699L7.62753 4.50699Z"
        fill="var(--app-main-progress-not-done-color)"
      />
      <defs>
        <clipPath id={clipId}>
          <rect width={(progress / 100) * 20} height="20" />
        </clipPath>
      </defs>
      <path
        d="M7.62753 4.50699C8.68337 2.61366 9.21087 1.66699 10 1.66699C10.7892 1.66699 11.3167 2.61366 12.3725 4.50699L12.6459 4.99699C12.9459 5.53533 13.0959 5.80449 13.3292 5.98199C13.5625 6.15949 13.8542 6.22533 14.4375 6.35699L14.9675 6.47699C17.0175 6.94116 18.0417 7.17283 18.2859 7.95699C18.5292 8.74033 17.8309 9.55783 16.4334 11.192L16.0717 11.6145C15.675 12.0787 15.4759 12.3112 15.3867 12.5978C15.2975 12.8853 15.3275 13.1953 15.3875 13.8145L15.4425 14.3787C15.6534 16.5595 15.7592 17.6495 15.1209 18.1337C14.4825 18.6178 13.5225 18.1762 11.6042 17.2928L11.1067 17.0645C10.5617 16.8128 10.2892 16.6878 10 16.6878C9.71087 16.6878 9.43837 16.8128 8.89337 17.0645L8.3967 17.2928C6.47753 18.1762 5.51753 18.6178 4.88003 18.1345C4.24087 17.6495 4.3467 16.5595 4.55753 14.3787L4.61253 13.8153C4.67253 13.1953 4.70253 12.8853 4.61253 12.5987C4.5242 12.3112 4.32503 12.0787 3.92837 11.6153L3.5667 11.192C2.1692 9.55866 1.47087 8.74116 1.7142 7.95699C1.95753 7.17283 2.98337 6.94033 5.03337 6.47699L5.56337 6.35699C6.14587 6.22533 6.4367 6.15949 6.67087 5.98199C6.90503 5.80449 7.0542 5.53533 7.3542 4.99699L7.62753 4.50699Z"
        fill="var(--app-main-star-color)"
        clipPath={`url(#${clipId})`}
      />
    </svg>
  );
};

const Stars = ({ k }) => {
  let totalProgress = k * 300;

  const first_progress = Math.min(100, totalProgress);
  totalProgress -= first_progress;

  const second_progress = Math.min(100, totalProgress);
  totalProgress -= second_progress;

  const third_progress = Math.min(100, totalProgress);
  return (
    <div className={styles.stars_row}>
      <Star progress={first_progress} />
      <Star progress={second_progress} />
      <Star progress={third_progress} />
    </div>
  )
}

export const RoadMapItem = ({ imgSrc, title, done, total, ind, onClick }) => {
  const k = (total !== 0) ? done / total : 1;
  const gridColumn = (ind % 2 === 0) ? "2" : "1";
  const gridRow = ind;
  return (
    <div className={styles.road_map_item} style={{ gridColumn, gridRow }} onClick={onClick}>
      <Image height="60px" width="60px" src={imgSrc} />
      <div className={styles.road_map_item_title}>
        {title}
      </div>
      <Stars k={k} />
      <div className={styles.road_map_item_progress_text}>
        {`${done}/${total}`}
      </div>
      <ProgressLine progress={k} />
      <div className={styles.ind_circle}>
        {ind}
      </div>
    </div>
  )
}

const getModulesText = (n) => {
  const num = Math.abs(n) % 100;
  const lastDigit = num % 10;

  if (num >= 11 && num <= 14) {
    return 'модулей';
  }

  if (lastDigit === 1) {
    return 'модуль';
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return 'модуля';
  }

  return 'модулей';
};

export const ProgressBlock = ({ k, motivationSystem, levelsLeft }) => {
  const progressCircle = <ProgressCircle
    progress={k}
    size={165}
    strokeWidth={14}
    backcolor="var(--app-main-block-color)"
  >
    <div className={styles.progress_percentage}>
      {(Number(k) * 100).toFixed(0)}%
    </div>
    <div>
      {getDate(new Date())}
    </div>
  </ProgressCircle>
  if (motivationSystem) {
    return (
      <div className={styles.progress_container}>
        <InfoBlock head="Цель" text="Уровень" level />
        {progressCircle}
        <InfoBlock head="Осталось" text={`${levelsLeft} ${getModulesText(levelsLeft)}`} />
      </div>
    )
  }
  else
    return (
      <div className={styles.only_progress_container}>
        {progressCircle}
      </div>
    )
}

export const InfoBlock = ({ head, text, level }) => {
  return (
    <div className={styles.info_block}>
      <div className={styles.info_block_head}>{head}</div>
      {level ? (
        <div className={styles.info_block_text_arrow}>
          <UpArrow style={{ flex: "0 0 auto" }} />
          <div className={styles.info_block_text}>{text}</div>
        </div>
      ) : (
        <div className={styles.info_block_text}>{text}</div>
      )}
    </div>
  );
};

export const ConnectionLines = ({ containerRef }) => {
  useEffect(() => {
    const drawLines = () => {
      if (!containerRef.current) return;

      const linesContainer = containerRef.current;
      const items = linesContainer.getElementsByClassName(styles.road_map_item);
      const existingLines = linesContainer.querySelectorAll('.connection-line');

      existingLines.forEach(line => line.remove());

      for (let i = 0; i < items.length - 1; i++) {
        const start = items[i].getBoundingClientRect();
        const end = items[i + 1].getBoundingClientRect();

        const containerRect = linesContainer.getBoundingClientRect();

        const x1 = start.left - containerRect.left + start.width / 2;
        const y1 = start.top - containerRect.top + start.height / 2;
        const x2 = end.left - containerRect.left + end.width / 2;
        const y2 = end.top - containerRect.top + end.height / 2;

        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.classList.add('connection-line');
        svg.style.position = 'absolute';
        svg.style.top = '0';
        svg.style.left = '0';
        svg.style.width = '100%';
        svg.style.height = '100%';
        svg.style.pointerEvents = 'none';
        svg.style.zIndex = '1';
        svg.setAttribute('viewBox', `0 0 ${containerRect.width} ${containerRect.height}`);

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        const pathData = `M ${x1} ${y1} L ${x2} ${y1} L ${x2} ${y2}`;
        path.setAttribute('d', pathData);
        path.setAttribute('stroke', '#dbdbdb');
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke-width', '2');
        path.setAttribute('stroke-dasharray', '7,7');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');

        svg.appendChild(path);
        linesContainer.appendChild(svg);
      }
    };

    drawLines();
    window.addEventListener('resize', drawLines);

    return () => {
      window.removeEventListener('resize', drawLines);
    };
  }, [containerRef]);

  return null;
};
